import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { SitemapListPage, SitemapDetailsPage } from '~features/sitemaps';

function SitemapPage() {
  return (
    <Routes>
      <Route path="" element={<SitemapListPage />}></Route>
      <Route path={`map/:id`} element={<SitemapDetailsPage />}></Route>
      {/* Absolute target: a relative `to` in a splat catch-all resolves against the full
          splat match in react-router 7 and would redirect onto itself forever. */}
      <Route path="*" element={<Navigate to="/sitemaps" replace />} />
    </Routes>
  );
}

export default SitemapPage;
